"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.captchaApi = captchaApi;
exports.getAdminInfoByTokenApi = getAdminInfoByTokenApi;
exports.getLoginPicApi = getLoginPicApi;
exports.login = login;
exports.logout = logout;
exports.userDetailApi = userDetailApi;
exports.userListApi = userListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function login(data) {
  return (0, _request.default)({
    url: '/admin/merchant/login',
    method: 'post',
    data: data
  });
}
function getAdminInfoByTokenApi() {
  return (0, _request.default)({
    url: '/admin/merchant/getAdminInfoByToken',
    method: 'get'
  });
}
function logout() {
  return (0, _request.default)({
    url: '/admin/merchant/logout',
    method: 'get'
  });
}

/**
 * 会员管理 列表
 * @param pram
 */
function userListApi(params) {
  return (0, _request.default)({
    url: "/admin/merchant/user/list",
    method: 'get',
    params: params
  });
}

/**
 *获取登录页图片
 */
function getLoginPicApi() {
  return (0, _request.default)({
    url: "/admin/merchant/getLoginPic",
    method: 'get'
  });
}

/**
 * @description 验证码
 */
function captchaApi() {
  return (0, _request.default)({
    url: "/publicly/validate/code/get",
    method: 'get'
  });
}

/**
 * @description 用户详情列表
 */
function userDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/merchant/user/detail/".concat(id),
    method: 'get'
  });
}